import { Box, makeStyles } from '@material-ui/core';
import { Pricing } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { PricingMinimalTable } from '@/components/shared/components/PricingsTable/components/PricingActionsRowDialog/components/PricingMinimalTable';
import { useRemovePricingFromAgent } from '@/components/shared/components/PricingsTable/components/PricingActionsRowDialog/hooks/useRemovePricingFromAgent';
import { PricingRowActionType } from '@/components/shared/components/PricingsTable/types/PricingRowActionType';
import { StandardActionDialog } from '@/components/shared/components/StandardActionDialog/StandardActionDialog';
import { Text } from '@/components/shared/components/Text';

interface RemovePricingFromAgentDialogProps {
  selectedPricing: Pricing;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  setRowPricingAction?: Dispatch<React.SetStateAction<PricingRowActionType | undefined>>;
}

export const RemovePricingFromAgentDialog = ({
  opened,
  setOpened,
  selectedPricing,
  setRowPricingAction,
}: RemovePricingFromAgentDialogProps) => {
  const { removePricingFromAgent, loading } = useRemovePricingFromAgent({ selectedPricing, setOpened });

  const useStyles = makeStyles({
    root: {
      '& .MuiDialog-paperWidthSm': { maxWidth: '750px' },
    },
  });

  const classes = useStyles();

  return (
    <StandardActionDialog
      titleTextElement={<Text tId={'REMOVE_PRICING_FROM_AGENT'} />}
      actionDescriptionTextElement={<Text tId={'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_PRICING_FROM_AGENT'} />}
      opened={opened}
      setOpened={setOpened}
      actionButtonsArray={[
        {
          onClick: () => removePricingFromAgent(),
          buttonLabelTextId: 'REMOVE_FROM',
        },
      ]}
      setActionDialogParams={setRowPricingAction}
      dialogProps={{ className: classes.root }}
      loading={loading}
    >
      <Box pt={3}>
        <PricingMinimalTable selectedPricing={selectedPricing} />
      </Box>
    </StandardActionDialog>
  );
};
